module.exports = "../study/imgs/maps/Tokyo/S8/Helth/HeatStress/Tokyo_HeatStress_MRI_RCP45_End.png";